<template>
	<div class="container">
		<div class="census">
			<el-image src="./static/image/head1.png" fit="cover"></el-image>
			<div class="range">
				<div class="title">
					{{$t('about.shi')}}
				</div>
				<span></span>
				<div class="title2">
					{{$t('about.hz')}}
				</div>
				<div class="text">
					Cooperation, development and innovation.
				</div>
			</div>
		</div>
		<div class="census">
			<el-image src="./static/image/head1.png" fit="cover"></el-image>
			<div class="range">
				<div class="title">
					{{$t('about.yj')}}
				</div>
				<span></span>
				<div class="title2">
					{{$t('about.zqiu')}}
				</div>
				<div class="text">
					Be a partner in global drug production and R & D, starting from <br>everyone, every product and every service.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.census {
			width: 100%;
			height: 300px;
			position: relative;
			margin-bottom: 40px;

			.el-image {
				width: 100%;
				height: 300px;
			}

			.range {
				width: 100%;
				height: 300px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				color: #fff;
				display: flex;
				align-items: center;
				flex-direction: column;
				font-size: 16px;
				padding: 50px 0;
				.title {
					font-size: 30px;
					font-weight: bold;
					margin-bottom: 10px;
				}
				.title2 {
					font-size: 24px;
					font-weight: bold;
					margin: 16px;
				}

				span {
					display: block;
					width: 40px;
					height: 3px;
					background: #FFFFFF;
					margin-bottom: 28px;
				}

				.text {
					text-align: center;
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/culture.vue